import React, { Component } from "react";
import { connect } from "react-redux";

import { Button, message, Steps, Popconfirm, Tag, Alert, Spin } from "antd";

import {
  req_single_people,
  req_add_afs_scholarshipsform,
  req_single_afs_timesetup,
} from "../../api";
import { getScholarshipAcademicSemester } from "../../utils/dateUtil";

import PicturesWall from "./pictures-wall";
import "./student-apply-scholarships.css";

const { Step } = Steps;
class StudentApplyScholarships extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    loading: false,
    relationtatus: 0,
    current: 0,
    steps: [
      {
        title: "申請說明",
        description: "申請前請備妥相關圖檔",
      },
      {
        title: "基本資料",
        description: "確認姓名、學籍狀態",
      },
      {
        title: "在學佐證",
        description: "上傳在學證明資料",
      },
      {
        title: "連絡方式",
        description: "電話、電郵等資料填寫",
      },
      {
        title: "校友關係",
        description: "填寫申請人與校友關係",
      },
      {
        title: "關係佐證",
        description: "上傳與校友關係資料",
      },
    ],
    timesetup: { NowStatus: "NA" },
    item: {},
    apply: {
      AcademicYear: "",
      AcademicSemester: getScholarshipAcademicSemester(new Date()),
      ApplicantId: "",
      ApplicantTwName: "",
      DivisionCode: "",
      DivisionTwName: "",
      EducationalSystemCode: "",
      EducationalSystemTwName: "",
      DepartmentRealCode: "",
      DepartmentTwName: "",
      ClassroomCode: "",
      ClassroomTwName: "",
      StudentCardFrontFileUrl: "",
      StudentCardBackFileUrl: "",
      EnrollmentLetterFileUrl: "",
      SchoolStatus: "",
      Cellphone: "",
      EMail: "",
      AlumniCategory: "未定",
      AlumniRelation: "",
      AlumniId: "",
      AlumniTwName: "",
      MembershipFileUrl: "",
      RelationFileUrl: "",
      DiplomaFileUrl: "",
    },
    finishPage: false,
  };

  constructor(props) {
    super(props);
    this.get_cardfrontimages = React.createRef();
    this.get_cardbackimages = React.createRef();
    this.get_enrollmentimages = React.createRef();
    this.get_membershipimages = React.createRef();
    this.get_relationimages = React.createRef();
    this.get_diplomaimages = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  UNSAFE_componentWillMount() {}

  componentDidMount() {
    this.api_single_item();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_single_item = async () => {
    const { apply } = this.state;
    const { token, userCode } = this.props.user;
    const item = await req_single_people(userCode, token);
    //console.log(item);
    apply.AcademicYear = item.AcademicYear;
    apply.ApplicantId = userCode;
    apply.ApplicantTwName = item.TwName;
    apply.DivisionCode = item.DivisionCode;
    apply.DivisionTwName = item.DivisionTwName;
    apply.EducationalSystemCode = item.EducationalSystemCode;
    apply.EducationalSystemTwName = item.EducationalSystemTwName;
    apply.DepartmentRealCode = item.DepartmentRealCode;
    apply.DepartmentTwName = item.DepartmentTwName;
    apply.ClassroomCode = item.ClassroomCode;
    apply.ClassroomTwName = item.ClassroomTwName;
    apply.Cellphone = item.Cellphone;
    apply.EMail = item.Email;
    apply.SchoolStatus = item.SchoolStatus;

    const data = await req_single_afs_timesetup("", token);
    const timesetup = data;
    this.setState({ item, apply, timesetup });
    console.log(timesetup);
  };

  api_add_item = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_afs_scholarshipsform(item, token);
    if (result.status === "success") {
      // console.log(result)
      message.success("申請已登錄，請等待審核!!");
      this.setState({ finishPage: true });
      // this.api_single_item();
    } else {
      message.error("已有申請資料，請勿重複申請!!");
    }
  };
  ///////////////////////////////////////////////////////////

  handleChange(event) {
    const { apply } = this.state;
    //console.log(event)
    Object.keys(apply).forEach((propertyName) => {
      if (event.target.id === "AgreePrivacy" && event.target.value !== null) {
        // Checkbox
        apply.AgreePrivacy = event.target.checked;
      } else {
        if (event.target.id === propertyName && event.target.value !== null) {
          apply[propertyName] = event.target.value.trim();
        }
      }
    });
    this.setState({ apply });
    //console.log(apply);
  }

  handleSubmit(event) {
    event.preventDefault();
    const { current, steps, relationtatus } = this.state;
    const row = this.state.apply;
    const errors = [];

    if (this.get_membershipimages.current) {
      const membershipimage = this.get_membershipimages.current.output_files();
      row.MembershipFileUrl = membershipimage[0];
    }
    if (this.get_relationimages.current) {
      const relationimage = this.get_relationimages.current.output_files();
      row.RelationFileUrl = relationimage[0];
    }
    if (this.get_diplomaimages.current) {
      const diplomaimage = this.get_diplomaimages.current.output_files();
      row.DiplomaFileUrl = diplomaimage[0];
    }

    if (current === steps.length - 1) {
      // 3.在學佐證
      // 在學驗證
      // if (typeof row.StudentCardFrontFileUrl === "undefined") {
      //   errors.push("未上傳學生證正面");
      // }
      // if (typeof row.StudentCardBackFileUrl === "undefined") {
      //   errors.push("未上傳學生證反面");
      // }
      if (
        row.EnrollmentLetterFileUrl === "" ||
        typeof row.EnrollmentLetterFileUrl === "undefined"
      ) {
        errors.push("未上傳在學證明");
      } else {
        if (row.EnrollmentLetterFileUrl.indexOf("rc-upload") !== -1) {
          errors.push("在學佐證資料驗證失敗");
        }
      }
      // 4.連絡方式
      if (!row.Cellphone.trim()) {
        errors.push("行動電話未填");
      } else {
        var regexPhone = /^09\d{8}$/;
        if (!regexPhone.test(row.Cellphone.trim())) {
          errors.push("行動電話格式錯誤");
        }
      }
      if (!row.EMail.trim()) {
        errors.push("電子郵件未填");
      } else {
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(row.EMail.trim())) {
          errors.push("電子郵件格式錯誤");
        }
      }

      // 5.校友關係驗證
      if (relationtatus === 0) {
        errors.push("未選擇您與校友關係");
      }
      if (!row.AlumniId.trim()) {
        errors.push("校友身份證字號未填");
      } else {
        var regex = /^[A-Z][0-9]{9}$/;
        if (!regex.test(row.AlumniId.trim().toString().toUpperCase())) {
          errors.push("校友身份證字號格式錯誤");
        } else {
          row.AlumniId = row.AlumniId.trim().toString().toUpperCase();
        }
      }
      if (!row.AlumniTwName.trim()) {
        errors.push("校友姓名未填");
      }
      if (!row.AlumniRelation.trim()) {
        errors.push("您與校友關係未填");
      }

      // 6.關係佐證
      if (relationtatus === 1) {
        row.RelationFileUrl = "";
      }
      if (relationtatus === 2) {
        if (typeof row.RelationFileUrl === "undefined") {
          errors.push("未上傳您與校友關係證明");
        } else {
          if (row.RelationFileUrl.indexOf("rc-upload") !== -1) {
            errors.push("資料傳輸中，請稍後");
          }
        }
      }
      if (
        row.DiplomaFileUrl === "" ||
        typeof row.DiplomaFileUrl === "undefined"
      ) {
        errors.push("未上傳校友畢業證書證明");
      } else {
        if (row.DiplomaFileUrl.indexOf("rc-upload") !== -1) {
          errors.push("資料傳輸中，請稍後");
        }
      }

      if (
        row.MembershipFileUrl === "" ||
        typeof row.MembershipFileUrl === "undefined"
      ) {
        errors.push("未上傳校友會入會證明");
      } else {
        if (row.MembershipFileUrl.indexOf("rc-upload") !== -1) {
          errors.push("資料傳輸中，請稍後");
        }
      }

      if (errors.length === 0) {
        //console.log(row);
        this.api_add_item(row);
      } else {
        let info = errors.join(",");
        message.error(info);
      }
    }
  }

  handleRelationStatus = (event) => {
    const { TwId } = this.state.item;
    event.preventDefault();
    const { value } = event.target;
    //console.log(value);
    var relationtatus = 0;
    const { apply } = this.state;
    switch (value) {
      case "未定":
        relationtatus = 0;
        apply.AlumniCategory = "未定";
        apply.AlumniRelation = "";
        apply.AlumniId = "";
        apply.AlumniTwName = "";
        break;
      case "本人":
        relationtatus = 1;
        apply.AlumniCategory = "本人";
        apply.AlumniRelation = "自己";
        apply.AlumniId = TwId;
        apply.AlumniTwName = apply.ApplicantTwName;
        break;
      case "親屬":
        relationtatus = 2;
        apply.AlumniCategory = "親屬";
        apply.AlumniRelation = "";
        apply.AlumniId = "";
        apply.AlumniTwName = "";
        break;
      default:
        console.log(`Sorry`);
    }
    this.setState({ relationtatus, apply });
  };

  next = () => {
    const { current, apply } = this.state;
    const row = apply;
    let dataCheck = true;
    // 0-基本資料
    // console.log(current);
    // 2-在學佐證
    if (current === 2) {
      const enrollmentLetter = this.get_enrollmentimages.current.output_files();
      if (typeof enrollmentLetter[0] === "undefined") {
        message.error("尚未上傳在學佐證資料");
        dataCheck = false;
      } else {
        if (enrollmentLetter[0].indexOf("rc-upload") !== -1) {
          message.error("在學佐證資料驗證失敗，請重傳");
          dataCheck = false;
        } else {
          apply.EnrollmentLetterFileUrl = enrollmentLetter[0];
        }
      }
    }
    // 3-連絡方式
    if (current === 3) {
      if (!row.Cellphone.trim()) {
        message.error("行動電話未填");
        dataCheck = false;
      } else {
        var regexPhone = /^09\d{8}$/;
        if (!regexPhone.test(row.Cellphone.trim())) {
          message.error("行動電話格式錯誤");
          dataCheck = false;
        }
      }
      if (!row.EMail.trim()) {
        message.error("電子郵件未填");
        dataCheck = false;
      } else {
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(row.EMail.trim())) {
          message.error("電子郵件格式錯誤");
          dataCheck = false;
        }
      }
    }
    // 4-校友關係
    if (current === 4) {
      let errors = [];
      if (row.AlumniCategory === "未定") {
        errors.push("請選擇與校友關係");
      }
      if (!row.AlumniRelation.trim()) {
        errors.push("請說明與校友關係");
      }
      if (!row.AlumniTwName.trim()) {
        errors.push("請輸入校友姓名");
      }
      if (!row.AlumniId.trim()) {
        errors.push("請輸入校友身份證字號");
      } else {
        var regex = /^[A-Z][0-9]{9}$/;
        if (!regex.test(row.AlumniId.trim().toString().toUpperCase())) {
          errors.push("校友身份證字號格式錯誤");
        }
      }

      if (errors.length > 0) {
        let info = errors.join(",");
        message.error(info);
        dataCheck = false;
      }
    }
    if (dataCheck === true) {
      this.setState({ current: current + 1, apply });
    }
  };

  prev = () => {
    const { current } = this.state;
    this.setState({ current: current - 1 });
  };

  /////////////////////////////
  render() {
    const fileUrlPath = "/api/UploadFile/AddInsideMediaFile";
    // const studentCardFrontFileUrl = [];
    // const StudentCardBackFileUrl = [];
    const EnrollmentLetterFileUrl = [];
    const MembershipFileUrl = [];
    const RelationFileUrl = [];
    const DiplomaFileUrl = [];
    const {
      ApplicantId,
      ApplicantTwName,
      DivisionTwName,
      EMail,
      Cellphone,
      EducationalSystemTwName,
      ClassroomTwName,
      AlumniCategory,
      AlumniRelation,
      AlumniId,
      AlumniTwName,
    } = this.state.apply;
    const { current, steps, finishPage, relationtatus, timesetup } = this.state;
    const { NowStatus } = timesetup;
    //console.log(this.state.item.StudentId);
    return finishPage ? (
      <div style={{ textAlign: "center", margin: "5px" }}>
        <Tag color="magenta" style={{ fontSize: "1.5em" }}>
          已經收到您的申請，請等待確認是否符合資格!!
        </Tag>
      </div>
    ) : (
      <form onSubmit={this.handleSubmit}>
        <>
          <div
            style={{
              backgroundColor: "#FDF9F8",
              border: "1px solid #F3F3F3",
              marginBottom: "1px",
            }}
          >
            <Steps current={current} direction="horizontal" size="small">
              {steps.map((item) => (
                <Step
                  key={item.title}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </Steps>
          </div>
          {NowStatus === "ON" ? (
            <>
              {" "}
              <div
                className="steps-content"
                style={{ border: "1px solid #F3F3F3" }}
              >
                {current === 0 ? (
                  <>
                    <div>
                      <Tag
                        color="magenta"
                        style={{ fontSize: "1.2em", marginTop: "10px" }}
                      >
                        申請前請確認是否有以下文件之圖檔
                      </Tag>
                      <div>
                        <ol>
                          <li>
                            1.<span style={{ color: "green" }}>(必須有)</span>
                            <span style={{ color: "blue", fontSize: "1.2em" }}>
                              在學證明
                            </span>
                            圖片，如何申請(
                            <a
                              href="https://regist-academic.tut.edu.tw/p/406-1032-460,r46.php?Lang=zh-tw"
                              target="_blank"
                              rel="noreferrer"
                              style={{
                                textDecoration: "underline",
                                fontWeight: "bold",
                              }}
                            >
                              日間部
                            </a>{" "}
                            ||{" "}
                            <a
                              href="https://tutforms.tut.edu.tw/Instructor/TUTForms?Unit=228"
                              target="_blank"
                              rel="noreferrer"
                              style={{
                                textDecoration: "underline",
                                fontWeight: "bold",
                              }}
                            >
                              進修部
                            </a>
                            )
                          </li>
                          <li>
                            2.<span style={{ color: "green" }}>(必須有)</span>
                            <span style={{ color: "blue", fontSize: "1.2em" }}>
                              校友本人畢業證書
                            </span>
                            圖片
                          </li>
                          <li>
                            3.<span style={{ color: "green" }}>(必須有)</span>
                            <span style={{ color: "blue", fontSize: "1.2em" }}>
                              校友本人
                              <span
                                style={{
                                  textDecoration: "underline",
                                  textDecorationStyle: "double",
                                  fontWeight: "bold",
                                }}
                              >
                                當年度校友會
                              </span>
                              入會繳費單據
                            </span>
                            圖片
                          </li>
                          <li>
                            4.{" "}
                            <span style={{ color: "red" }}>
                              校友為親屬，而非申請者本人則
                            </span>
                            <span style={{ color: "green" }}>(必須有)</span>
                            <span style={{ color: "blue", fontSize: "1.2em" }}>
                              與校友關係證明(例：戶口名簿並註明關係)
                            </span>
                            圖片
                          </li>
                          <li>
                            <div class="highlight">5. 本項獎助金與本校「教職員工本人及配偶子女就讀本校獎助辦法」僅能擇一申請</div>
                          </li>
                        </ol>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
                {current === 1 ? (
                  <>
                    <div className="form-row">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label>班級</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="ClassroomTwName"
                            id="ClassroomTwName"
                            defaultValue={ClassroomTwName}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label>學號</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="ApplicantId"
                            id="ApplicantId"
                            defaultValue={ApplicantId}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label>姓名</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="ApplicantTwName"
                            id="ApplicantTwName"
                            aria-describedby="ApplicantTwName"
                            defaultValue={ApplicantTwName}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>部別</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="DivisionTwName"
                            id="DivisionTwName"
                            defaultValue={DivisionTwName}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>學制</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="EducationalSystemTwName"
                            id="EducationalSystemTwName"
                            defaultValue={EducationalSystemTwName}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
                {current === 2 ? (
                  <>
                    <div className="form-row">
                      <div className="col-lg">
                        <div className="form-group">
                          <label>
                            <span
                              className="text-danger"
                              style={{ fontWeight: "bold", fontSize: "1.2em" }}
                            >
                              *
                            </span>
                            在學證明，如何申請(
                            <a
                              href="https://regist-academic.tut.edu.tw/p/406-1032-460,r46.php?Lang=zh-tw"
                              target="_blank"
                              rel="noreferrer"
                              style={{
                                textDecoration: "underline",
                                fontWeight: "bold",
                              }}
                            >
                              日間部
                            </a>{" "}
                            ||{" "}
                            <a
                              href="https://tutforms.tut.edu.tw/Instructor/TUTForms?Unit=228"
                              target="_blank"
                              rel="noreferrer"
                              style={{
                                textDecoration: "underline",
                                fontWeight: "bold",
                              }}
                            >
                              進修部
                            </a>
                            ) )
                          </label>
                          <PicturesWall
                            ref={this.get_enrollmentimages}
                            images_source={EnrollmentLetterFileUrl}
                            api_url={fileUrlPath}
                            self_filename="在學證明"
                          ></PicturesWall>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
                {current === 3 ? (
                  <>
                    <div className="form-row">
                      <div className="col-lg">
                        <div className="form-group">
                          <label>
                            <span
                              className="text-danger"
                              style={{ fontWeight: "bold", fontSize: "1.2em" }}
                            >
                              *
                            </span>
                            行動電話
                          </label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="Cellphone"
                            id="Cellphone"
                            placeholder="請輸入您常用行動電話"
                            defaultValue={Cellphone}
                            onChange={this.handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg">
                        <div className="form-group">
                          <label>
                            <span
                              className="text-danger"
                              style={{ fontWeight: "bold", fontSize: "1.2em" }}
                            >
                              *
                            </span>
                            電子郵件
                          </label>
                          <input
                            type="email"
                            className="form-control text-primary"
                            name="EMail"
                            id="EMail"
                            aria-describedby="emailHelp"
                            placeholder="請輸入您常用電子郵件"
                            defaultValue={EMail}
                            onChange={this.handleChange}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
                {current === 4 ? (
                  <>
                    <div className="form-row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label>
                            {" "}
                            <span
                              className="text-danger"
                              style={{ fontWeight: "bold", fontSize: "1.2em" }}
                            >
                              *
                            </span>
                            申請類別
                          </label>
                          <select
                            name="AlumniCategory"
                            id="AlumniCategory"
                            className="custom-select mb-3 text-success"
                            defaultValue={AlumniCategory}
                            onChange={(AlumniCategory) =>
                              this.handleRelationStatus(AlumniCategory)
                            }
                            key={AlumniCategory}
                          >
                            {" "}
                            <option value="未定">請選擇</option>
                            <option value="本人">本人即校友</option>
                            <option value="親屬">親屬為校友</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label>
                            {" "}
                            <span
                              className="text-danger"
                              style={{ fontWeight: "bold", fontSize: "1.2em" }}
                            >
                              *
                            </span>
                            與校友關係
                          </label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="AlumniRelation"
                            id="AlumniRelation"
                            placeholder="例如：兄弟姊妹/兒女/祖孫"
                            defaultValue={AlumniRelation}
                            onChange={this.handleChange}
                            disabled={
                              relationtatus === 0
                                ? true
                                : relationtatus === 1
                                ? true
                                : false
                            }
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label>
                            {" "}
                            <span
                              className="text-danger"
                              style={{ fontWeight: "bold", fontSize: "1.2em" }}
                            >
                              *
                            </span>
                            校友姓名
                          </label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="AlumniTwName"
                            id="AlumniTwName"
                            defaultValue={AlumniTwName}
                            onChange={this.handleChange}
                            disabled={
                              relationtatus === 0
                                ? true
                                : relationtatus === 1
                                ? true
                                : false
                            }
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label>
                            {" "}
                            <span
                              className="text-danger"
                              style={{ fontWeight: "bold", fontSize: "1.2em" }}
                            >
                              *
                            </span>
                            校友身分證字號
                          </label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="AlumniId"
                            id="AlumniId"
                            defaultValue={AlumniId}
                            onChange={this.handleChange}
                            disabled={
                              relationtatus === 0
                                ? true
                                : relationtatus === 1
                                ? true
                                : false
                            }
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
                {current === 5 ? (
                  <>
                    <div className="form-row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>
                            <span
                              className="text-danger"
                              style={{ fontWeight: "bold", fontSize: "1.2em" }}
                            >
                              *
                            </span>
                            說明：拍照可識別即可
                          </label>
                          <PicturesWall
                            ref={this.get_diplomaimages}
                            images_source={DiplomaFileUrl}
                            api_url={fileUrlPath}
                            self_filename="校友本人畢業證書"
                          ></PicturesWall>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>
                            <span
                              className="text-danger"
                              style={{ fontWeight: "bold", fontSize: "1.2em" }}
                            >
                              *
                            </span>
                            說明： 校友本人當年度的校友會入會證明
                          </label>
                          <PicturesWall
                            ref={this.get_membershipimages}
                            images_source={MembershipFileUrl}
                            api_url={fileUrlPath}
                            self_filename=" 校友本人當年度校友會入會繳費單據"
                          ></PicturesWall>
                        </div>
                      </div>
                      <div
                        className="col-lg"
                        style={{
                          display: relationtatus === 1 ? "none" : "block",
                        }}
                      >
                        <div className="form-group">
                          <label>
                            <span
                              className="text-danger"
                              style={{ fontWeight: "bold", fontSize: "1.2em" }}
                            >
                              *
                            </span>
                            例如：戶口名簿並註明關係
                          </label>
                          <PicturesWall
                            ref={this.get_relationimages}
                            images_source={RelationFileUrl}
                            api_url={fileUrlPath}
                            self_filename="與校友關係證明"
                          ></PicturesWall>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
              <div className="steps-action" style={{ marginTop: "4px" }}>
                {current < steps.length - 1 && (
                  <button
                    className={
                      NowStatus === "OFF"
                        ? "btn btn-sm btn-secondary"
                        : "btn btn-sm btn-primary"
                    }
                    onClick={this.next}
                    disabled={NowStatus === "OFF"}
                  >
                    {NowStatus === "OFF" ? "未開放" : "下一步"}
                  </button>
                )}
                {current === steps.length - 1 && (
                  <>
                    <Popconfirm
                      title="因應個人資料保護法及本校個人資料管理規定，本校在向您蒐集個人資料之前，依法向您告知下列事項，當您送出申請即「我同意」，表示您已閱讀、瞭解並同意接受本同意書之所有內容：
                                    一、蒐集目的及類別
                                    為提供活動各項通知服務、報名資料確認、寄送本校或產業相關活動訊息及本校內部管理使用之蒐集目的，而須獲取您下列個人資料類別： 姓名、電話、E-mail 或其他得以直接或間接識別您個人之資料。
                                    二、個人資料利用之期間、地區、對象及方式
                                    您的個人資料，除涉及國際業務或活動外，僅供本校及活動協辦單位於中華民國領域，於上述蒐集目的之必要合理範圍內加以利用至前述蒐集目的消失時為止。
                                    
                                    三、當事人權利行使
                                    依據個人資料保護法第3條規定，您可向本校請求查詢或閱覽、製給複製本、補充或更正、停止蒐集/處理/利用或刪除您的個人資料。
                                    
                                    四、不提供個人資料之權益影響
                                    如您不提供或未提供正確之個人資料，或要求停止蒐集/處理/利用/刪除個人資料、服務訊息的取消訂閱，本校將無法為您提供蒐集目的之相關服務。
                                    
                                    五、各項通知服務、相關訊息之停止寄送，或違反本個資聲明之行為。您可於上班時間聯繫承辦人（電話06-2535642，分機 227、229）反映。
                                     
                                    個人資料同意提供：
                                    一、本人確已閱讀並瞭解上述告知事項，並勾選「我同意」授權貴校於所列目的之必要合理範圍內，蒐集、處理及利用本人之個人資料。
                                    二、本人瞭解此同意書符合個人資料保護法及相關法規之要求，並提供予貴校留存及日後查證使用。"
                      cancelText="了解"
                    >
                      <Button type="link">
                        註：送出即同意[蒐集個資告知事項暨個人資料]宣告
                      </Button>
                    </Popconfirm>
                    <button
                      type="submit"
                      className="btn btn-success btn-sm"
                      disabled={NowStatus === "OFF"}
                    >
                      送出
                    </button>
                  </>
                )}
                {/* {current > 0 &&
                  (current === steps.length - 1 ? (
                    ""
                  ) : (
                    <button
                      className="btn btn-light btn-sm"
                      style={{
                        margin: "0 8px",
                      }}
                      onClick={this.prev}
                      disabled={NowStatus === "OFF"}
                    >
                      上一頁
                    </button>
                  ))} */}
              </div>
            </>
          ) : NowStatus === "NA" ? (
            <div className="text-center">
              {" "}
              <Spin size="large" style={{ marginTop: "20px" }} tip="檢核中" />
            </div>
          ) : (
            <>
              {" "}
              <Alert
                message=""
                description="尚未開放"
                type="warning"
                showIcon
                closable
              />
            </>
          )}
        </>
      </form>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(StudentApplyScholarships);
